<template>
    <div class="AdminImport">
        <FadeTransition mode="out-in">
            <div
                class="AdminImportHeader flex row-stretch-center"
                :class="{ 'Separate': store.buttons || breadcrumbs}"
            >
                <Breadcrumbs :breadcrumbs="breadcrumbs" />
                <div
                    v-if="store.buttons"
                    class="flex"
                >
                    <Reload v-if="store.reload" />
                    <WButton
                        v-for="({ text, disabled, onClick, ...otherProps }, index) in store.buttons"
                        :key="index"
                        :disabled="disabled"
                        v-bind="otherProps"
                        class="ml-1"
                        @click="onClick"
                    >
                        {{ text }}
                    </WButton>
                </div>
            </div>
        </FadeTransition>
        <Transition
            name="main-router"
            mode="out-in"
        >
            <RouterView />
        </Transition>
    </div>
</template>

<script>
import { Breadcrumbs, Reload } from '@/components'

export default {
    name: 'AdminUsers',
    components: {
        Breadcrumbs,
        Reload,
    },
    provide () {
        return {
            Entity: this,
        }
    },
    data () {
        return {
            store: {},
        }
    },
    computed: {
        breadcrumbs () {
            const { breadcrumbs } = this.store

            return [
                {
                    key: 'AdminUsers',
                    label: this.$t('admin.navigation.users'),
                    to: { name: 'AdminUsers' },
                },
                ...(breadcrumbs || ((this.$route.meta || {}).breadcrumb ? [{
                    key: this.$route.name,
                    label: this.$route.meta.breadcrumb,
                    to: { name: this.$route.name },
                }] : [])),
            ]
        },
    },
}
</script>

<style lang="scss" scoped>
.AdminImportHeader{
    &.Separate {
        margin-bottom: 20px;
    }
}
</style>
